<div   [ngClass]="{'mt-1': cashback, 'inline': inline}" >
  <span class="text-black font24"> {{this.getPontos()}}</span>
  <label  *ngIf="!cashback">{{cartao?.plano?.tipoDeAcumulo}}</label>
</div>
